module.exports = __webpack_public_path__ + "img/Payments.00b90efb.svg";